export const baseURL = import.meta.env.VITE_DOMAIN_NAME_FRONT_END+"/v1";
export const cdnURL = import.meta.env.VITE_CDN_URL
export const sessionKey = import.meta.env.VITE_ENCRYPTION_SECRET;
export const stage = import.meta.env.VITE_STAGE;